import { css } from 'aphrodite';
import React, { FC, useLayoutEffect, useRef } from 'react';
import Modal from 'react-modal';
import { style } from './style';

Modal.setAppElement('#root');

interface Props {
  isOpen: boolean;
  message: string;
  onContinue: () => any;
  onExit: () => any;
}

export const IncompletionModal: FC<Props> = ({ isOpen, onContinue, onExit, message }) => {
  const styles = style();
  const scrollPosition = useRef<number>();

  useLayoutEffect(() => {
    const $body = document.body;
    // Save the user's current scroll position so that when the modal is closed the user will be at the same position
    scrollPosition.current = window.pageYOffset;
    $body.style.overflow = 'hidden';
    $body.style.position = 'fixed';
    $body.style.width = '100%';
    $body.style.top = `-${scrollPosition.current}px`;
  }, []);

  const handleEvent = (onEvent: any) => {
    // Unlock body scrolling and restore the scroll position
    onEvent();
    const $body = document.body;
    $body.style.removeProperty('overflow');
    $body.style.removeProperty('position');
    $body.style.removeProperty('top');
    $body.style.removeProperty('width');
    window.scrollTo(0, scrollPosition.current || 0);
  };

  const { title, content, leaveButtonText, stayButtonText } = JSON.parse(message);

  return (
    <Modal
      closeTimeoutMS={300}
      isOpen={isOpen}
      className={css(styles.modal)}
      overlayClassName={css(styles.overlay)}
      shouldCloseOnOverlayClick={true}
      onRequestClose={onContinue}>
      <div className={css(styles.modalContent)}>
        <h1 className={css(styles.title)}>{title}</h1>
        <div className={css(styles.content)} dangerouslySetInnerHTML={{ __html: content }}></div>
        <div className={css(styles.buttonsContainer)}>
          <button className={css(styles.button, styles.stayButton)} onClick={() => handleEvent(onContinue)}>
            {stayButtonText || 'Continue'}
          </button>
          <button className={css(styles.button, styles.leaveButton)} onClick={() => handleEvent(onExit)}>
            {leaveButtonText || 'Exit'}
          </button>
        </div>
      </div>
    </Modal>
  );
};
